<flx-heading-with-instructions [title]="title" [instructions]="instructions" [headingConfig]="headingConfig"></flx-heading-with-instructions>
<flx-key-value-list [data$]="keyValueList$"></flx-key-value-list>
